import { Pipe, PipeTransform } from '@angular/core';
import { UserManagement } from 'src/services/api-services/api-interfaces/userManagement.interface';
@Pipe({
    name: 'filterUserManagements',
    standalone: false
})
  export class FilterUserManagement implements PipeTransform {
    transform(items:(UserManagement[] | null), UserEmail: string, UserState:string, UserName:string, UserCountry:string, UserRole:string): UserManagement[] {
        if (!items) {
            return [];
          }
          if (!UserEmail && !UserState && !UserName && !UserCountry && !UserRole) {
            return items;
          }

          //  change de words a lower case example ASD = asd
          const normalize = (value: unknown): string => String(value ?? '').trim().toLocaleLowerCase();
          UserEmail = normalize(UserEmail);
          UserState = normalize(UserState);
          UserName = normalize(UserName);
          UserCountry = normalize(UserCountry);
          UserRole = normalize(UserRole);

          
          return items.filter(item => {
            
            const stateLabels = item?.isActive
              ? ['activo', 'active', 'true', '1', 'sí', 'si']
              : ['inactivo', 'inactive', 'false', '0', 'no'];
            const UserEmailMatch = normalize(item?.email).includes(UserEmail);
            const UserStateMatch = !UserState || stateLabels.some(label => label.startsWith(UserState));
            const UserNameMatch = normalize(item?.userName).includes(UserName);
            const countryNameMatch = normalize(item?.countryName).includes(UserCountry);
            const UserRoleMatch = normalize(item?.roleName).includes(UserRole);
            return UserEmailMatch && UserStateMatch&& UserNameMatch && countryNameMatch && UserRoleMatch;
          });
      
    }
  }
